module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAUBAMAAABscEDKAAAAMFBMVEUAQMAqYMo0aM02aM1AcNBjithojtmBoeCWsOW/zu/X4fXf5/fh6fj4+v38/f7///8PP/VDAAAAQElEQVQY02P4jwIYdqMABpIAxIi/96FGQajv9cjcU1M81yBxm0UDLZC4j/K/6eHmoilGMwrNIoQzSAJo3kcNHAA4B65jqvGgrwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./client/src/images/flags/il.png
// module id = 841
// module chunks = 0